import { useInfiniteList } from "@refinedev/core";
import { ChatHistoryResponse } from "types";
import { getNextPageParamWithServerPagination } from "utils/pagination/";

export const useChatHistory = ({
  projectId,
  params,
  enabled = true,
}: {
  projectId: string;
  enabled?: boolean;
  params: {
    page: number;
    size: number;
    from_datetime?: string;
    to_datetime?: string;
  };
}) => {
  // The list endpoint expects `from_date` / `to_date` query params (see
  // get_chat_history_projects__project_id__chat_history_get in media.d.ts) and
  // accepts plain YYYY-MM-DD values, like the chat_history/export endpoint.
  // Sending `from_datetime` / `to_datetime` was silently ignored by the backend,
  // so the date range never filtered anything.
  const queryKeyByParam: Record<string, string> = {
    from_datetime: "from_date",
    to_datetime: "to_date",
  };

  const queryParams = Object.entries(params)
    .filter(
      ([key, param]) => param !== undefined && key !== "page" && key !== "size"
    )
    .map(([key, param]) => [queryKeyByParam[key] ?? key, String(param)]);

  const queryString = new URLSearchParams(queryParams);

  const { data, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useInfiniteList<ChatHistoryResponse>({
      resource: `media/projects/${projectId}/chat_history?${queryString}`,
      queryOptions: {
        enabled,
        getNextPageParam: getNextPageParamWithServerPagination(params.size),
      },
      pagination: {
        pageSize: params.size,
      },
    });

  return {
    data: data?.pages,
    isLoading,
    isFetching,
    hasNextPage,
    fetchNextPage,
  };
};
